class CreationPersonnalisee {

    constructor() {
        this.keys = ['top', 'bottom', 'sleeves', 'collar'];
        this.cartItems = {
            top: document.querySelector("#bundle-cart-item-top"),
            bottom: document.querySelector("#bundle-cart-item-bottom"),
            sleeves: document.querySelector("#bundle-cart-item-sleeves"),
            collar: document.querySelector("#bundle-cart-item-collar")
        };
        this.cartTotal = document.querySelector("button.bundle-cart-item-cta");
        this.currency = this.cartTotal.dataset.currency;
        this.cartTotalPrice = this.cartTotal.querySelector(".price");
        const _this = this;
        this.cartIcon = document.querySelector('.header__secondary-nav a[href$="/cart"]');
        this.cartTotal.addEventListener('click', function () { _this.addToCart() });
    }

    openCartDrawer() {
        const expanded = this.cartIcon.getAttribute("aria-expanded");
        if(!expanded || expanded == "false") {
            this.cartIcon.click();
        }
    }

    addToCart() {
        let items = [];
        let updates = {}; 
        this.keys.forEach((id) => {
            const currentItem = this[id];
            if(currentItem) {
                const variantId = parseInt(currentItem.variantId);
                updates[variantId] = 1;
                items.push({
                id: variantId, 
                quantity: 1
                });
            }
        });

        if(items.length == 0) {
            return;
        }
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'post',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({updates: updates})
        })
        .then(response => response.json())
        .then((cartContent) => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));
            this.openCartDrawer();
        })
        .catch((e) =>{
            console.log(e);
        });
    }

    selectVariant(id, item) {
        if(this[id]) {
            this[id].item.classList.remove("is-selected");
        }

        item.classList.add("is-selected");
        this[id] = {};
        this[id].item = item;
        this[id].variantId = item.dataset.variantId;
        this[id].price = parseFloat(item.dataset.price);
        this.cartItems[id].querySelector(".bundle-cart-item-price").textContent = item.dataset.priceWithCurrency;
        this.updateCartTotal();
    }

    toFinancialRepresentation(x) {
        return Number.parseFloat(x).toFixed(2);
    }
    
    updateCartTotal() {
        let totalPriceValue = 0;
        this.keys.forEach((id) => {
            const currentItem = this[id];
            if(currentItem) {
                totalPriceValue += currentItem.price;
            }
        });

        this.cartTotalPrice.textContent = `${this.toFinancialRepresentation(totalPriceValue)} ${this.currency}`;
    }
}

window.onload = function () {
    const creation = new CreationPersonnalisee();

    function setHandlers() {
        let variantOptions = document.querySelectorAll(`.variant-picker-option`);
        variantOptions.forEach((variantOption) => {
            variantOption.addEventListener('click', function (event) {
                creation.selectVariant(variantOption.dataset.type, event.target);
            });
        });
    }

    setHandlers();

    creation.keys.forEach((id) => {
        const currentItem = creation[id];
        if(!currentItem) {
            const cartItems = creation.cartItems[id]; 
            if(cartItems) {
                cartItems.querySelector(`.variant-picker-option`).click();
            }
        }
    });
}